import { Toggle } from '@g17eco/molecules/toggle';
import { ASSIGNMENT } from '@constants/terminology';

interface SystemUsersToggleProps {
  checked: boolean;
  onChange: () => void;
  className?: string;
}

// Mirrors UserStatsTable's 'Platform delegated users' switch: utrvDelegation off, totalDelegation on
export const SystemUsersToggle = ({ checked, onChange, className = 'mb-3' }: SystemUsersToggleProps) => (
  <Toggle
    className={{ form: `d-flex align-items-center pl-0 ${className}` }}
    checked={checked}
    onChange={onChange}
    label={`${ASSIGNMENT.roleAccess} users`}
  />
);
